import type { DocumentSessionInfo, OnlyOfficeSession } from 'types/documentEditing';
import { isRecord } from 'utils/typeChecks';

export const postDocumentSession = (frame: HTMLIFrameElement, session: OnlyOfficeSession): void => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = session.actionUrl;
  form.target = frame.name;
  form.hidden = true;
  form.className = 'ph-no-capture sentry-block';
  const fields: Record<string, string> = {
    access_token: session.accessToken,
    access_token_ttl: String(session.accessTokenTtl),
    docs_api_config: JSON.stringify({ document: { permissions: { comment: session.canComment === true } } }),
  };
  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.append(input);
  }
  document.body.append(form);
  try {
    form.submit();
  } finally {
    form.remove();
  }
};

export const getDocumentMessage = (event: MessageEvent, frame: HTMLIFrameElement, origin: string): string | null => {
  if (event.origin !== origin || !frame.contentWindow || event.source !== frame.contentWindow) return null;
  try {
    const value: unknown = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    return isRecord(value) && typeof value.MessageId === 'string' ? value.MessageId : null;
  } catch {
    return null;
  }
};

export const sendDocumentHostReady = (frame: HTMLIFrameElement, origin: string): void => {
  frame.contentWindow?.postMessage(JSON.stringify({ MessageId: 'Host_PostmessageReady', SendTime: Date.now(), Values: {} }), origin);
};

export const sendDocumentFocus = (frame: HTMLIFrameElement, origin: string, overlayOpen: boolean, session: DocumentSessionInfo): void => {
  if (!session.canEdit && !session.canReview && !session.canComment) return;
  if (
    !overlayOpen &&
    (!(session.canEdit || session.canReview) || !/^\/hosting\/wopi\/(?:word|slide)\/(?:edit|view)$/.test(new URL(session.actionUrl).pathname))
  ) {
    const hostWindow = frame.contentWindow;
    if (hostWindow?.length === 1) hostWindow.frames[0].focus();
    else frame.focus();
    return;
  }
  frame.contentWindow?.postMessage(
    JSON.stringify({ MessageId: overlayOpen ? 'Blur_Focus' : 'Grab_Focus', SendTime: Date.now(), Values: {} }),
    origin
  );
};
